import React, { useEffect, useState } from 'react'
import ModalBase from "../../modals/base"
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import Times from '../../common/formParts/icons/Times.svg'
import background from '../../common/formParts/img/geo-bg-img-top.jpg'
import dummyHeader from '../../common/formParts/img/dummy-header.png'
import dummyButton from '../../common/formParts/img/dummy-button.png'
import dummyFooter from '../../common/formParts/img/dummy-footer.png'
import dottedLine from '../../common/formParts/img/dotted-line.png'
import downloadSVG from '../../../packs/users/img/icons/Download.svg'

const dateOptions = { timeZone: 'Asia/Tokyo'}
const dateOptionsJapaneseFormat = {year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Tokyo'}

const dayOfWeekinJapanese = (selectedDate) => {
  const dayOfWeek = new Date(selectedDate).getDay()
  return ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'][dayOfWeek] || ''
}

const OccurenceDateTime = (props) => {
  const occurenceDateTimeType = props.dateTimeType || 'none'
  const easyNewsType = props.selectedNewsType || '1'
  switch (occurenceDateTimeType) {
    case 'day_time':
      const occurenceDateTimeSelected = document.querySelector('input[name="easy_news[occurence_datetime]"]').value
      const occurenceDate = new Date(occurenceDateTimeSelected).toLocaleDateString('ja-JP', dateOptionsJapaneseFormat)
      const dayOfWeekJp = dayOfWeekinJapanese(occurenceDateTimeSelected)
      let occurenceTime = new Date(occurenceDateTimeSelected).toLocaleTimeString('ja-JP', dateOptions)
      occurenceTime = occurenceTime === '0:01:00' ? '夜間' : occurenceTime.slice(0, -3)
      occurenceTime = occurenceTime === '12:01' ? '日中' : occurenceTime
      occurenceTime = occurenceTime === '4:01' ? '早朝' : occurenceTime
      occurenceTime = occurenceTime === '22:01' ? '深夜' : occurenceTime
      occurenceTime = occurenceTime === '23:58' ? '' : occurenceTime
      return (
        <>
          <div>
            <span>{occurenceTime === '' ? '日付 : ' : '日時 : '}</span><span>{occurenceDate}{dayOfWeekJp} {occurenceTime} {occurenceTime !== '' && props.aboutTimeStart && '頃'}</span>
          </div>
        </>
      )
      break
    case 'day_time_range':
      const occurenceDateTimeStartSelected = document.querySelector('input[name="easy_news[occurence_start_datetime]"]').value
      const occurenceDateTimeEndSelected = document.querySelector('input[name="easy_news[occurence_end_datetime]"]').value
      let occurenceDateStart = new Date(occurenceDateTimeStartSelected).toLocaleDateString('ja-JP', dateOptionsJapaneseFormat)
      let occurenceTimeStart = new Date(occurenceDateTimeStartSelected).toLocaleTimeString('ja-JP', dateOptions)
      let occurenceTimeEnd = new Date(occurenceDateTimeEndSelected).toLocaleTimeString('ja-JP', dateOptions)
      const dayOfWeek = dayOfWeekinJapanese(occurenceDateTimeStartSelected)

      occurenceTimeStart = occurenceTimeStart === '0:01:00' ? '夜間' : occurenceTimeStart.slice(0, -3)
      occurenceTimeStart = occurenceTimeStart === '12:01' ? '日中' : occurenceTimeStart
      occurenceTimeStart = occurenceTimeStart === '4:01' ? '早朝' : occurenceTimeStart
      occurenceTimeStart = occurenceTimeStart === '22:01' ? '深夜' : occurenceTimeStart

      occurenceTimeStart = occurenceTimeStart === '23:58' ? '' : occurenceTimeStart
      occurenceTimeEnd = occurenceTimeEnd === '0:01:00' ? '夜間' : occurenceTimeEnd.slice(0, -3)
      occurenceTimeEnd = occurenceTimeEnd === '12:01' ? '日中' : occurenceTimeEnd
      occurenceTimeEnd = occurenceTimeEnd === '4:01' ? '早朝' : occurenceTimeEnd
      occurenceTimeEnd = occurenceTimeEnd === '22:01' ? '深夜' : occurenceTimeEnd
      occurenceTimeEnd = occurenceTimeEnd === '23:58' ? '' : occurenceTimeEnd
      return (
        <>
          <div>
            <span>{occurenceTimeStart === '' && occurenceTimeEnd === '' ? '日付 : ' : '日時 : '}</span>
            <span>
              {occurenceDateStart}{dayOfWeek} 
              {occurenceTimeStart} {occurenceTimeStart !== '' && props.aboutTimeStart && '頃'} {occurenceTimeStart !== '' && 'から'}
              {occurenceTimeEnd} {occurenceTimeEnd !== '' && props.aboutTimeEnd && '頃'} {occurenceTimeEnd !== '' && 'まで'}
            </span>
          </div>
        </>
      )
      break
    case 'day_range':
      const occurenceRangeDateTimeStartSelected = document.querySelector('input[name="easy_news[occurence_start_datetime]"]').value
      const occurenceRangeDateTimeEndSelected = document.querySelector('input[name="easy_news[occurence_end_datetime]"]').value
      let occurenceRangeDateStart = new Date(occurenceRangeDateTimeStartSelected).toLocaleDateString('ja-JP', dateOptionsJapaneseFormat)
      let occurenceRangeTimeStart = new Date(occurenceRangeDateTimeStartSelected).toLocaleTimeString('ja-JP', dateOptions)
      let occurenceRangeDateEnd = new Date(occurenceRangeDateTimeEndSelected).toLocaleDateString('ja-JP', dateOptionsJapaneseFormat)
      let occurenceRangeTimeEnd = new Date(occurenceRangeDateTimeEndSelected).toLocaleTimeString('ja-JP', dateOptions)
      occurenceRangeTimeStart = occurenceRangeTimeStart === '0:01:00' ? '夜間' : occurenceRangeTimeStart.slice(0, -3)
      occurenceRangeTimeStart = occurenceRangeTimeStart === '12:01' ? '日中' : occurenceRangeTimeStart
      occurenceRangeTimeStart = occurenceRangeTimeStart === '4:01' ? '早朝' : occurenceRangeTimeStart
      occurenceRangeTimeStart = occurenceRangeTimeStart === '22:01' ? '深夜' : occurenceRangeTimeStart

      occurenceRangeTimeStart = occurenceRangeTimeStart === '23:58' ? '' : occurenceRangeTimeStart
      occurenceRangeTimeEnd = occurenceRangeTimeEnd === '0:01:00' ? '夜間' : occurenceRangeTimeEnd.slice(0, -3)
      occurenceRangeTimeEnd = occurenceRangeTimeEnd === '12:01' ? '日中' : occurenceRangeTimeEnd
      occurenceRangeTimeEnd = occurenceRangeTimeEnd === '4:01' ? '早朝' : occurenceRangeTimeEnd
      occurenceRangeTimeEnd = occurenceRangeTimeEnd === '22:01' ? '深夜' : occurenceRangeTimeEnd
      occurenceRangeTimeEnd = occurenceRangeTimeEnd === '23:58' ? '' : occurenceRangeTimeEnd
      const dayOfWeekStart = dayOfWeekinJapanese(occurenceRangeDateTimeStartSelected)
      const dayOfWeekEnd = dayOfWeekinJapanese(occurenceRangeDateTimeEndSelected)

      return (
        <>
          <div>
            <span>期間 : </span>
            <span>
              {occurenceRangeDateStart}{dayOfWeekStart} {occurenceRangeTimeStart} {occurenceRangeTimeStart !== '' && props.aboutTimeStart && '頃'} から<br />
              {occurenceRangeDateEnd}{dayOfWeekEnd} {occurenceRangeTimeEnd} {occurenceRangeTimeEnd !== '' && props.aboutTimeEnd && '頃'} まで
            </span>
          </div>
        </>
      )
      break
    case 'none':
      return null
    default:
      return null
      break
  }
}

const ConfirmModal = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(props.isVisible || false)
  const [noDataToDisplay, setNoDataToDisplay] = useState(false)
  const [articleName, setArticleName] = useState('')
  const [publishNow, setPublishNow] = useState('')
  const [formattedPublishDate, setFormattedPublishDate] = useState('')
  const [publishDate, setPublishDate] = useState('')
  const [title, setTitle] = useState('')
  const [categoryDetail, setCategoryDetail] = useState('')
  const [details, setDetails] = useState('')
  const [occurenceLocation, setOccurenceLocation] = useState('')
  const [occurenceDateTimeType, setOccurenceDateTimeType] = useState('')
  const [aboutTime, setAboutTime] = useState(false)
  const [aboutTimeStart, setAboutTimeStart] = useState(false)
  const [aboutTimeEnd, setAboutTimeEnd] = useState(false)
  const [attachments, setAttachments] = useState([])
  const [remarks, setRemarks] = useState('')
  const [easyNewsType, setEasyNewsType] = useState('')

  const dateAsYMD = (stringDate) => {
    const date = new Date(stringDate)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}/${month}/${day}`
  }

  const getSelectedData = () => {
    // Article
    const articleNameSelect = document.getElementById('easy_news_article_id')
    if (!articleNameSelect) {
      setNoDataToDisplay(true)
      return
    } else {
      const articleNameSelected = articleNameSelect.options[articleNameSelect.selectedIndex].text || ''
      setArticleName(articleNameSelected)
    }

    // Publish Date
    const publishNowSelected = document.querySelector('input[name="easy_news[publish_now]"]')
    let publishDateSelected = ''
    let formattedPublishDateSelected = ''
    if (publishNowSelected !== null && publishNowSelected.value == 1) {
      setPublishNow('すぐに配信する')
    } else {
      setPublishNow('')
    }
    const publishDateValue = document.querySelector('input[name="easy_news[publish_datetime]"]').value
    publishDateSelected = new Date(publishDateValue).toLocaleString('ja-JP', dateOptions).replace('T', ' ')
    setPublishDate(publishDateSelected)
    formattedPublishDateSelected = dateAsYMD(publishDateValue)
    setFormattedPublishDate(formattedPublishDateSelected)

    // Easy News Type
    setEasyNewsType(props.selectedNewsType)

    // title
    const titleSelected = document.querySelector('input[name="easy_news[title]"]').value
    setTitle(titleSelected)

    // category Detail
    const categoryDetailSelected = document.querySelector('input[name="easy_news[easy_news_category_detail_id]"]').value
    props.easy_news_category_details.map((categoryDetail) => {
      if (categoryDetail.id == categoryDetailSelected) {
        setCategoryDetail(categoryDetail.name)
      }
    })

    // details
    const detailsSelected =document.getElementById('easy_news_details').value
    setDetails(detailsSelected)

    // occurence Location
    const occurenceLocationSelected = document.querySelector('input[name="easy_news[occurence_location]"]').value
    setOccurenceLocation(occurenceLocationSelected)

    // occurence DateTime Type
    const occurenceDateTimeTypeSelected = document.querySelector('input[name="easy_news[occurence_datetime_type]"]').value
    setOccurenceDateTimeType(occurenceDateTimeTypeSelected)

    // about time
    // const aboutTimeSelected = document.querySelector('input[name="easy_news[about_time]"]').checked
    // setAboutTime(aboutTimeSelected)

    // about start time
    const aboutTimeStartSelected = document.querySelector('input[name="easy_news[about_time_start]"]').checked
    setAboutTimeStart(aboutTimeStartSelected)

     // about end time
     const aboutTimeEndSelected = document.querySelector('input[name="easy_news[about_time_end]"]').checked
     setAboutTimeEnd(aboutTimeEndSelected)

    // attachments
    const attachmentsSelecteds = document.querySelectorAll('input[id^="easy_news_easy_news_files_attributes_"]')
    const attachmentsSelected = Array.from(attachmentsSelecteds).filter(input =>
        /^easy_news_easy_news_files_attributes_\d+_title$/.test(input.id)
    );
    const anchorTexts = attachmentsSelected.map(input => input.value)
    setAttachments(anchorTexts)

    // remarks
    const remarksSelected = document.getElementById('easy_news_remarks').value
    setRemarks(remarksSelected)

    // Update states
    setNoDataToDisplay(false)
  }

  const handleOnClose = () => {
    setIsModalVisible(false)
  }

  const setModalVisible = (value) => {
    setIsModalVisible(value)
  }

  useEffect(() => {
    if (isModalVisible) { getSelectedData() }
  }, [isModalVisible])

  const submitForm = () => {
    const form = document.querySelector('.main-content__body form')
    form.submit()
  }

  return (
    <ModalBase isVisible={isModalVisible} setModalVisible={setModalVisible} fullWidth={true} >
      <Inner>
        <div className="modal-header">
          <h3>以下の内容でお知らせを登録します、よろしいですか？</h3>
          <div className="modal-close" onClick={handleOnClose}>
            <SVG src={Times} className="icon" title="閉じる" />
          </div>
        </div>
        <div className="modal-body">
          {noDataToDisplay ? <div className="empty-data">配信先が選択されていないようです。</div>
            :
            <div>
              <h2>配信する物件</h2>
              <p className="dottedBottom">{articleName}</p>
              <h2>配信日時</h2>
              <p className="dottedBottom">{publishNow !== '' ?  publishNow : publishDate}</p>
              <h2>配信内容</h2>
              <Preview>
                <div className="preview-inner">
                  <img src={dummyHeader} alt="ヘッダー" />
                  <div className="preview-scroller">
                    <h1>{title}</h1>
                    <div className="preview-body">
                      <time className="preview-date">{formattedPublishDate}</time>
                      <div className="trix-content preview-bg" dangerouslySetInnerHTML={{__html: details}} />
                      <div className="content-details">
                        <OccurenceDateTime dateTimeType={occurenceDateTimeType} aboutTimeStart={aboutTimeStart} aboutTimeEnd={aboutTimeEnd} selectedNewsType={props.selectedNewsType}/>
                        {occurenceLocation != '' && occurenceLocation != null && (<div><span>{'場所 : '}</span><span>{occurenceLocation}</span></div>)}
                        {remarks != '' && remarks != null && (
                          <div><span>備考 : </span><span><div className="trix-content" dangerouslySetInnerHTML={{__html: remarks}} /></span></div>
                        )}
                      </div>
                      {attachments.length > 0 && (
                      <>
                      <hr className="attachment-spacer" />
                      添付ファイル
                      <div className='attachments'>
                        {attachments.map((attachment) => {
                          return (
                            <a href="#" target="_blank" onClick={
                              (e) => {
                                e.preventDefault()
                              }
                            }>{attachment}
                            <SVG src={downloadSVG} className="icon" title="ダウンロード" />
                            </a>
                          )
                        })}
                      </div>
                      </>
                      )}
                      <p className="align-right">
                        以上
                      </p>
                    </div>
                    <div className="button-container">
                      <img src={dummyButton} alt="戻るボタン" />
                    </div>
                  </div>
                  <img src={dummyFooter} alt="フッター" className="footer-img" />
                </div>
              </Preview>
            </div>
          }
        </div>
        <ActionFooter>
        <input type="button" value="キャンセル" className="btn btn-secondary" onClick={handleOnClose} />
        <input type="button" value="登録する" className="btn btn-primary" onClick={submitForm}/>
        </ActionFooter>
      </Inner>
    </ModalBase>
  )
}

export default ConfirmModal

const Preview = styled.div`
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 14px;
  margin: auto;
  width: 415px;
  height: 707px;
  padding: 1.25rem;
  background-color: #666;
  border-radius: 20px;
  @media (max-height: 840px) {
    transform: scale(0.9);
  }
  @media (max-height: 760px) {
    transform: scale(0.8);
  }
  @media (max-height: 720px) {
    transform: scale(0.75);
  }
  img {
    vertical-align: bottom;
  }
  .endDateTime {
    margin-left: 2.4rem;
  }
  .align-right {
    text-align: right;
  }
  .preview-inner {
    background-color: #f5f5f5;
  }
  .preview-scroller {
    height: 524px;
    line-height: 24px;
    overflow-y: auto;
    overflow-x: hidden;
    > h1 {
      margin: 0 0 1.063rem;
      padding: 1.75rem 1rem 1rem;
      font-size: 19px;
      font-weight: normal;
      line-height: 24px;
      text-align: left;
      color: #7F0073;
      word-break: break-all;
      border-bottom: 2px solid #a69057;
    }
  }
  .preview-body {
    padding: 0 16px 32px;
    pointer-events: none;
    .content-details {
      > div {
        display: flex;
        align-items: flex-start;
        margin-bottom: 8px;
        span {
          font-size: 14px;
          &:first-child {
            flex: 0 0 auto;
            margin-right: 4px;
            font-weight: bold;
          }
          &:last-child {
            flex: 1 1 auto;
          }
        }
      }
    }
  }
  .preview-bg {
    margin: 16px 0;
    background-color: #f5f5f5;
  }
  .trix-content {
    color: #555;
    * {
      line-height: 24px;
      word-break: break-all;
    }
    a {
      display: block;
      color: #7F0073;
      text-decoration: underline;
    }
    h1 {
      line-height: 24px;
      padding: 0;
      margin: 12px 0;
      color: #0a0a0a;
      font-size: 16px;
      font-weight: bold;
    }
    .attachment-gallery {
      > action-text-attachment,
      > .attachment {
        flex: 1 0 33%;
        padding: 0 0.5em;
        max-width: 33%;
      }
      &.attachment-gallery--2,
      &.attachment-gallery--4 {
        > action-text-attachment,
        > .attachment {
          flex-basis: 50%;
          max-width: 50%;
        }
      }
    }
    pre {
      display: inline-block;
      width: 100%;
      vertical-align: top;
      font-family: monospace;
      color: #666;
      font-size: 1rem;
      padding: 0.5rem;
      white-space: pre;
      background-color: #eee;
      overflow-x: auto;
      white-space: pre-wrap;
    }
    blockquote {
      border: 0 solid #ccc;
      border-left-width: 4px;
      margin-left: 0;
      padding-left: 0.75rem;
    }
    hr {
      margin-top: 1em;
      margin-bottom: 1em;
    }
    strong {
      color: inherit !important;
    }
    ul,
    ol {
      margin-left: 15px;
      li {
        margin-left: 0;
      }
    }
    ul {
      list-style: disc;
    }
    ol {
      list-style: decimal;
    }
    .attachment {
      padding: 0 !important;
      max-width: 100% !important;
    }
    .attachment__caption {
      text-align: center;
      .attachment__name,
      .attachment__size {
        display: none;
      }
    }
    x-font-red {
      color: rgba(255, 0, 0, 0.726);
    }
    x-font-blue {
      color: rgba(0, 68, 255, 0.726);
    }
    x-font-green {
      color: rgba(9, 112, 0, 0.726);
    }
  }
  div {
    color: #555;
    word-break: break-all;
  }
  p {
    margin-bottom: 0;
    color: #555;
    word-break: break-all;
  }
  .categoryDetailPreview {
    margin-top: 0.5rem;
  }
  hr {
    &.attachment-spacer {
      margin: 20px 0;
      padding: 0;
      border: 0;
      border-bottom: 1px solid #777;
    }
  }
  .attachments {
    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-decoration: none;
      transition: 0.4s;
      color: #555;
      padding: 0.5rem;
      margin: 0.25rem 0 0.5rem;
      border: 1px solid #ddd;
      background-color: white;
      border-radius: 0.4rem;
      word-break: break-all;
      .icon {
        flex: 0 0 auto;
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.25rem;
        color: #7F0073;
      }
    }
  }
  .button-container {
    padding: 40px 0;
    border-top: 2px solid #ddd;
    text-align: center;
    img {
      width: 243px;
      height: auto;
    }
  }
  .footer-img {
    box-shadow: 0px -2px 5px -3px #777777;
  }
`;

const ActionFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #ccc;
  .btn {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .btn-secondary {
    background-color: #ccc;
    color: #000;
    font-weight: normal;
    :hover {
      background-color: #bbb;
    }
  }
  .btn-primary {
    background-color: #FAB500;
    color: #fff;
    font-weight: normal;
    :hover {
      background-color: #FFC900;
    }
  }
`;

const Inner = styled.div`
  position: absolute;
  width: 80%;
  max-width: 800px;
  background: white;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  border-radius: 4px;
  .modal-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1rem;
    padding: 1.25rem 0;
    border-bottom: 1px solid #ccc;
    h3 {
      font-size: 16px;
      font-weight: 400;
    }
    .modal-close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      right: 16px;
      width: 32px;
      height: 32px;
      transform: translateY(-50%);
      border-radius: 50%;
      transition: background-color .2s;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, .1);
      }
    }
  }
  .modal-body {
    min-height: 100px;
    max-height: 80vh;
    padding: 1rem 0 2rem;
    overflow-y: auto;
    overflow-x: hidden;
    .modal-block {
      position: relative;
      padding: 1.5rem 1rem;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 1rem;
        right: 1rem;
        border-bottom: 1px solid #ccc;
      }
    }
    h2 {
      margin: 1rem;
    }
    .empty-data {
      padding: 3rem 0 2rem;
      color: #556;
      text-align: center;
    }
  }
  .dottedBottom {
    margin: 0 1rem 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px dashed #ccc;
  }
`;
